import { render, staticRenderFns } from "./checkedComponent.vue?vue&type=template&id=9ddb1de6&scoped=true"
import script from "./checkedComponent.vue?vue&type=script&lang=js"
export * from "./checkedComponent.vue?vue&type=script&lang=js"
import style0 from "./checkedComponent.vue?vue&type=style&index=0&id=9ddb1de6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddb1de6",
  null
  
)

export default component.exports